// extracted by mini-css-extract-plugin
export default {"container":"settingManagement_container__HmGDm","heading":"settingManagement_heading__eIMX6","form":"settingManagement_form__jy7+b","error":"settingManagement_error__weyup"};